import { ApiErrorSchema, MyBookingsResponseSchema, type MyBookingsResponse } from '@ah/contracts';

/** Thin fetch wrapper for the bookings endpoints — same shape as the other apps' *.api.ts files. */
export class BookingsApi {
  constructor(private readonly baseUrl: string) {}

  async listMine(accessToken: string): Promise<MyBookingsResponse> {
    const res = await fetch(`${this.baseUrl}/api/v1/bookings/my`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res.ok) throw await this.toError(res);
    return MyBookingsResponseSchema.parse(await res.json());
  }

  private async toError(res: Response): Promise<Error> {
    try {
      const payload = ApiErrorSchema.parse(await res.json());
      return new BookingsApiError(payload.error.code, payload.error.message, res.status);
    } catch {
      return new BookingsApiError('INTERNAL_ERROR', res.statusText, res.status);
    }
  }
}

export class BookingsApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'BookingsApiError';
  }
}
